import AttendeeSearch from "./attendee_search"

const RegistrationsNewModal = {
  initialize() {
    return AttendeeSearch.init("new")
  }
}

export default RegistrationsNewModal
